export const USER_NOT_FOUND = 'User NOT found'
export const JWT_EXPIRED = 'jwt expired'
export const JWT_MUST_PROVIDED = 'jwt must be provided'
export const END_OF_TRIAL_SUBSCRIPTION = 'Trial subscribtion the end'